import axios from './axios';

export const getQuestionsByDomain = (domainCode) => axios.post('/api/Questions/List', {
	  "limit": 1000,
	  "offset": 0,
	  "filter": {
			"code": domainCode
	  },
	  "sorting": {
		"fieldName": "id",
		"direction": "asc"
	  }
	});

// export const getQuestionsByDomain = (domainCode) => {
//   return new Promise((resolve) => {
//     resolve({
//       data: {
//         messages: [],
//         succeeded: true,
//         data: [
//           {
//             id: 1,
//             question: "The child reacts attentively to the sound sours.",
//             description: "Sound Games-Use toys that make sounds (like rattles or musical toys)..."
//           },
//           {
//             id: 2,
//             question: "Looks toward vocal sounds (e.g., raspberry, whistle).",
//             description: "Vocal Play- Make silly noises, like raspberries or high-pitched sounds..."
//           },
//           {
//             id: 3,
//             question: "Turnes toward to voice the person",
//             description: "Sound Games- Use different sounds—like clapping, bells, or rattles..."
//           },
//           {
//             id: 4,
//             question: "Notices the nearby object when it’s pointed out",
//             description: "Pointing and Naming- While holding the baby, point to nearby objects..."
//           },
//           {
//             id: 5,
//             question: "The child directs attention to a nearby spot as they organize objects into containers.",
//             description: "Tactile Exploration- Provide textured objects..."
//           },
//           {
//             id: 6,
//             question: "Turns when name is called",
//             description: "Interactive Play- Sit close to your baby and softly call their name..."
//           },
//           {
//             id: 7,
//             question: "The child pays attention to a close reference to successfully navigate to the objects or location.",
//             description: "Visual Tracking with Toys- Use a brightly coloured toy..."
//           },
//           {
//             id: 8,
//             question: "Notices the object in the distance upon hearing, “(Child’s name), look at that!”",
//             description: "Nature Touch and Feel- If you're near safe natural items..."
//           },
//           {
//             id: 9,
//             question: "The child engages by looking, reaching, and smiling in reaction to an adult's voice and movements in a social setting.",
//             description: "Peek-a-Boo-Play peek-a-boo while varying your voice and expressions..."
//           },
//           {
//             id: 10,
//             question: "The child keeps interest and enjoys participating in a play routine with you",
//             description: "Building Projects-Use blocks or stacking toys..."
//           },
//           {
//             id: 11,
//             question: "The child reacts appropriately to at least one spoken request.",
//             description: "Simple Commands -Use simple commands like “Come” or “Give.”..."
//           },
//           {
//             id: 12,
//             question: "Reacts to \"no\" by stopping attempt to grab the object",
//             description: "Interactive Play: Play games where you gently say \"Stop\"..."
//           },
//           {
//             id: 13,
//             question: "The child responds to a one-step routine verbal direction involving body movements independently of gestures",
//             description: "Engaging Activities- Play this game to practice following commands..."
//           },
//           {
//             id: 14,
//             question: "The child correctly points out various one object (Ball, cup, spoon)",
//             description: "Flashcards- Create or use flashcards with pictures of the objects..."
//           },
//           {
//             id: 15,
//             question: "The child successfully identifies the specified item in the surroundings (such as a fan, chair, or door).",
//             description: "Room Tour- Take a tour of a room and ask the child to point out specific items..."
//           }
//         ],
//         exception: null,
//         code: 0
//       }
//     });
//   });
// };
